const siteMonitor = () => import("@/views/oper-manage/site-monitor/site-monitor.vue");
const siteMonitorOper = () => import("@/views/oper-manage/site-monitor/children/site-monitor-oper/site-monitor-oper.vue");
const siteMonitorDetails = () => import("@/views/oper-manage/site-monitor/children/site-monitor-details/site-monitor-details.vue");
const siteMonitorGunDetails = () => import("@/views/oper-manage/site-monitor/children/site-monitor-gun-details/site-monitor-gun-details.vue");
const userGuide = () => import("@/views/oper-manage/user-guide/user-guide.vue");
const catalogList = () => import("@/views/oper-manage/user-guide/children/catalog-list/catalog-list.vue");
const addCatalog = () => import("@/views/oper-manage/user-guide/children/add-catalog/add-catalog.vue");
const upCatalog = () => import("@/views/oper-manage/user-guide/children/up-catalog/up-catalog.vue");
const addArticle = () => import("@/views/oper-manage/user-guide/children/add-article/add-article.vue");
const upArticle = () => import("@/views/oper-manage/user-guide/children/up-article/up-article.vue");
const nonRealNameCardManagement = () => import("@/views/oper-manage/non-real-name-card-management/non-real-name-card-management.vue");
const nonRealNameCardDetail = () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-detail.vue");
const nonRealAddCard = () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-add-card/non-real-add-card.vue");
const nonRealRecharge = () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-recharge.vue");
const nonRealDelCard = () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-del-card.vue");
const nonRealEditCard = () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-edit-card.vue");
const nonRealHistory = () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-history.vue");
const nonFundHistory = () => import("@/views/oper-manage/non-real-name-card-management/children/non-fund-history.vue");
const nonRealRefund = () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-refund.vue");
const nonRealAddCardPc = () => import("@/views/oper-manage/non-real-name-card-management/children/non-real-add-card-pc.vue");
//
const realNameCardManagement = () => import("@/views/oper-manage/real-name-card-management/real-name-card-management.vue");
const fundData = () => import("@/views/oper-manage/fund-data/fund-data.vue");
const userAnalysis = () => import("@/views/oper-manage/user-analysis/user-analysis.vue");
const memberGrade = () => import("@/views/oper-manage/member-grade/member-grade.vue");
const addmemberGrade = () => import("@/views/oper-manage/member-grade/children/add-member-grade/add-member-grade.vue");
const upMemberGrade = () => import("@/views/oper-manage/member-grade/children/up-member-grade/up-member-grade.vue");
const detailsMemberGrade = () => import("@/views/oper-manage/member-grade/children/details-member-grade/details-member-grade.vue");
const memberGradeRecordDetails = () => import("@/views/oper-manage/member-grade/children/grade-record-details/grade-record-details.vue");
const commodity = () => import("@/views/oper-manage/points-mall/commodity/commodity.vue");
const addCommodity = () => import("@/views/oper-manage/points-mall/commodity/children/add-goods/add-goods.vue");
const updataCommodity = () => import("@/views/oper-manage/points-mall/commodity/children/updata-goods/updata-goods.vue");
const detailsCommodity = () => import("@/views/oper-manage/points-mall/commodity/children/details-goods/details-goods.vue");
const commodityOrder = () => import("@/views/oper-manage/points-mall/commodity-order/commodity-order.vue");
const commodityOrderDetails = () => import("@/views/oper-manage/points-mall/commodity-order/children/commodity-order-details/commodity-order-details.vue");
const mallConfig = () => import("@/views/oper-manage/points-mall/mall-config/mall-config.vue");
const routerList = [
    {
        path: "/oper-manage/site-monitor",
        name: "站点监控",
        component: siteMonitor,
        children: [
            {
                path: "/oper-manage/site-monitor/oper",
                name: "运营商站点监控详情",
                component: siteMonitorOper,
                meta: {
                    nameKey: "siteMonitorOper",
                },
            },
            {
                path: "/oper-manage/site-monitor/site-details",
                name: "站点监控详情",
                component: siteMonitorDetails,
                meta: {
                    nameKey: "siteMonitorDetails",
                },
            },
            {
                path: "/oper-manage/site-monitor/site-details/details",
                name: "站点监控站详情",
                component: siteMonitorGunDetails,
                meta: {
                    nameKey: "siteMonitorGunDetails",
                },
            },
        ],
    },
    // {
    //   path: "/oper-manage/invoice-info",
    //   name: "发票信息",
    //   component: invoiceInfo,
    // },
    // {
    //   path: "/oper-manage/invoice-info/details",
    //   name: "发票详情",
    //   component: invoiceInfoDetails,
    //   meta: {
    //     nameKey: "invoiceDetails",
    //   },
    // },
    // {
    //   path: "/oper-manage/invoice-info/to-examine",
    //   name: "发票审核",
    //   component: invoiceInfoAudit,
    //   meta: {
    //     nameKey: "invoiceAudit",
    //   },
    // },
    {
        path: "/oper-manage/marketing/coupon",
        name: "优惠券",
        // component: coupon,
        component: () => import("@/views/oper-manage/marketing/coupon/coupon.vue"),
        children: [
            {
                path: "/oper-manage/marketing/coupon/add",
                name: "新增优惠券",
                component: () => import("@/views/oper-manage/marketing/coupon/children/add-coupon/add-coupon.vue"),
                meta: {
                    nameKey: "couponAdd",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/marketing/coupon/details",
                name: "优惠券详情",
                component: () => import("@/views/oper-manage/marketing/coupon/children/details-coupon/details-coupon.vue"),
                meta: {
                    nameKey: "couponDetails",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/marketing/coupon/up",
                name: "修改优惠券",
                component: () => import("@/views/oper-manage/marketing/coupon/children/updata-coupon/updata-coupon.vue"),
                meta: {
                    nameKey: "couponAddUp",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/marketing/coupon/audit",
                name: "审核优惠券",
                component: () => import("@/views/oper-manage/marketing/coupon/children/audit-coupon/audit-coupon.vue"),
                meta: {
                    nameKey: "couponAudit",
                },
            },
            {
                path: "/oper-manage/marketing/coupon/grant",
                name: "发放优惠券",
                component: () => import("@/views/oper-manage/marketing/coupon/children/grant-coupon/grant-coupon.vue"),
                meta: {
                    nameKey: "couponGrant",
                },
            },
        ],
    },
    {
        path: "/oper-manage/marketing/user-coupon",
        name: "用户优惠券",
        component: () => import("@/views/oper-manage/marketing/user-coupon/user-coupon.vue"),
    },
    {
        path: "/oper-manage/marketing/member-coupon",
        name: "营销活动",
        component: () => import("@/views/oper-manage/marketing/member-coupon/member-coupon.vue"),
        children: [
            {
                path: "/oper-manage/marketing/member-coupon/grant",
                name: "活动发放优惠券",
                // component: grantCoupon,
                component: () => import("@/views/oper-manage/marketing/member-coupon/children/grant-coupon/grant-coupon.vue"),
                meta: {
                    nameKey: "memberCouponGrant",
                },
            },
            {
                path: "/oper-manage/marketing/member-coupon/add",
                name: "新增营销活动",
                component: () => import("@/views/oper-manage/marketing/member-coupon/children/add-member-coupon/add-member-coupon.vue"),
                meta: {
                    nameKey: "memberCouponAdd",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/marketing/member-coupon/up",
                name: "修改营销活动",
                component: () => import("@/views/oper-manage/marketing/member-coupon/children/up-member-coupon/up-member-coupon.vue"),
                meta: {
                    nameKey: "memberCouponUp",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/marketing/member-coupon/audit",
                name: "审核营销活动",
                component: () => import("@/views/oper-manage/marketing/member-coupon/children/audit-member-coupon/audit-member-coupon.vue"),
                meta: {
                    nameKey: "memberCouponAudit",
                },
            },
            {
                path: "/oper-manage/marketing/member-coupon/details",
                name: "营销活动详情",
                component: () => import("@/views/oper-manage/marketing/member-coupon/children/details-member-coupon/details-member-coupon.vue"),
                meta: {
                    nameKey: "memberCouponDetails",
                },
            },
        ],
    },
    {
        path: "/oper-manage/message/system-notice",
        name: "系统公告",
        component: () => import("@/views/oper-manage/message/system-notice/system-notice.vue"),
        children: [
            {
                path: "/oper-manage/message/system-notice/add",
                name: "新增系统公告",
                component: () => import("@/views/oper-manage/message/system-notice/children/add-system-notice/add-system-notice.vue"),
                meta: {
                    nameKey: "noticeAdd",
                },
            },
            {
                path: "/oper-manage/message/system-notice/details",
                name: "系统公告详情",
                component: () => import("@/views/oper-manage/message/system-notice/children/details-system-notice/details-system-notice.vue"),
                meta: {
                    nameKey: "noticeDetails",
                },
            },
        ],
    },
    {
        path: "/oper-manage/message/customer-service",
        name: "客户消息",
        component: () => import("@/views/oper-manage/message/customer-service/customer-service.vue"),
        children: [
            {
                path: "/oper-manage/message/customer-service/reply",
                name: "客户消息回复",
                component: () => import("@/views/oper-manage/message/customer-service/children/reply-msg/reply-msg.vue"),
                meta: {
                    nameKey: "customerServiceReply",
                },
            },
        ],
    },
    {
        path: "/oper-manage/user-guide",
        name: "用户指南",
        component: userGuide,
        children: [
            {
                path: "/oper-manage/user-guide/catalog",
                name: "目录管理",
                component: catalogList,
                meta: {
                    nameKey: "userGuideCatalog",
                },
            },
            {
                path: "/oper-manage/user-guide/add-catalog",
                name: "新增目录",
                component: addCatalog,
                meta: {
                    nameKey: "userGuideCatalogAdd",
                },
            },
            {
                path: "/oper-manage/user-guide/up-catalog",
                name: "修改目录",
                component: upCatalog,
                meta: {
                    nameKey: "userGuideCatalogUp",
                },
            },
            {
                path: "/oper-manage/user-guide/add-article",
                name: "新增文章",
                component: addArticle,
                meta: {
                    nameKey: "userGuideArticleAdd",
                },
            },
            {
                path: "/oper-manage/user-guide/up-article",
                name: "修改文章",
                component: upArticle,
                meta: {
                    nameKey: "userGuideArticleUp",
                },
            },
        ],
    },
    {
        path: "/oper-manage/non-real-name-card-management",
        name: "非实名卡管理",
        component: nonRealNameCardManagement,
        children: [
            {
                path: "/oper-manage/non-real-name-card-management/non-real-name-card-detail",
                name: "非实名卡详情",
                component: nonRealNameCardDetail,
                meta: {
                    nameKey: "cardDetails",
                },
            },
            {
                path: "/oper-manage/non-real-name-card-management/non-real-add-card",
                name: "非实名卡-开卡",
                component: nonRealAddCard,
                meta: {
                    nameKey: "cardAdd",
                },
            },
            {
                path: "/oper-manage/non-real-name-card-management/non-real-recharge",
                name: "非实名卡-充值",
                component: nonRealRecharge,
                meta: {
                    nameKey: "cardRecharge",
                },
            },
            {
                path: "/oper-manage/non-real-name-card-management/non-real-edit-card",
                name: "非实名卡-编辑",
                component: nonRealEditCard,
                meta: {
                    nameKey: "cardUp",
                },
            },
            {
                path: "/oper-manage/non-real-name-card-management/non-real-del-card",
                name: "非实名卡-注销",
                component: nonRealDelCard,
                meta: {
                    nameKey: "cardDel",
                },
            },
            {
                path: "/oper-manage/non-real-name-card-management/non-real-history",
                name: "非实名卡-操作记录",
                component: nonRealHistory,
                meta: {
                    nameKey: "cardHistory",
                },
            },
            {
                path: "/oper-manage/non-real-name-card-management/non-fund-history",
                name: "非实名卡-资金记录",
                component: nonFundHistory,
                meta: {
                    nameKey: "cardFundHistory",
                },
            },
            {
                path: "/oper-manage/non-real-name-card-management/non-real-refund",
                name: "非实名卡退款",
                component: nonRealRefund,
                meta: {
                    nameKey: "cardRefund",
                },
            },
            {
                path: "/oper-manage/non-real-name-card-management/non-real-add-card-pc",
                name: "非实名卡发卡",
                component: nonRealAddCardPc,
            },
        ],
    },
    {
        path: "/oper-manage/real-name-card-management",
        name: "实名卡管理",
        component: realNameCardManagement,
    },
    {
        path: "/oper-manage/fund-data",
        name: "资金数据",
        component: fundData,
    },
    // {
    //   path: "/oper-manage/msg-center",
    //   name: "消息中心",
    //   component: msgCenter
    // },
    // {
    //   path: "/oper-manage/system-msg",
    //   name: "系统公告",
    //   component: systemMsg
    // },
    {
        path: "/oper-manage/user-analysis",
        name: "用户分析",
        component: userAnalysis,
    },
    {
        path: "/oper-manage/member-grade",
        name: "会员等级管理",
        component: memberGrade,
        children: [
            {
                path: "/oper-manage/member-grade/add",
                name: "新增会员等级",
                component: addmemberGrade,
                meta: {
                    nameKey: "memberGradeAdd",
                },
            },
            {
                path: "/oper-manage/member-grade/updata",
                name: "修改会员等级",
                component: upMemberGrade,
                meta: {
                    nameKey: "memberGradeUp",
                },
            },
            {
                path: "/oper-manage/member-grade/details",
                name: "会员等级详情",
                component: detailsMemberGrade,
                meta: {
                    nameKey: "memberGradeDetails",
                },
            },
            {
                path: "/oper-manage/member-grade/record-details",
                name: "等级购买记录详情",
                component: memberGradeRecordDetails,
                meta: {
                    nameKey: "memberGradeRecordDetails",
                },
            },
        ],
    },
    {
        path: "/oper-manage/integral-activity/manage",
        name: "积分活动管理",
        component: () => import("@/views/oper-manage/integral-activity/integral-activity-manage/integral-activity-manage.vue"),
        children: [
            {
                path: "/oper-manage/integral-activity/manage/add",
                name: "新增积分活动",
                component: () => import("@/views/oper-manage/integral-activity/integral-activity-manage/children/activity-manage-add/activity-manage-add.vue"),
                meta: {
                    nameKey: "integralActivityAdd",
                },
            },
            {
                path: "/oper-manage/integral-activity/manage/updata",
                name: "修改积分活动",
                component: () => import("@/views/oper-manage/integral-activity/integral-activity-manage/children/activity-manage-updata/activity-manage-updata.vue"),
                meta: {
                    nameKey: "integralActivityUp",
                },
            },
            {
                path: "/oper-manage/integral-activity/manage/details",
                name: "积分活动详情",
                component: () => import("@/views/oper-manage/integral-activity/integral-activity-manage/children/activity-manage-details/activity-manage-details.vue"),
                meta: {
                    nameKey: "integralActivityDetails",
                },
            },
        ],
    },
    {
        path: "/oper-manage/integral-activity/record",
        name: "积分记录",
        component: () => import("@/views/oper-manage/integral-activity/integral-activity-record/integral-activity-record.vue"),
        children: [
            {
                path: "/oper-manage/integral-activity/record/details",
                name: "积分兑换记录详情",
                component: () => import("@/views/oper-manage/integral-activity/integral-activity-record/children/integral-record-details/integral-record-details.vue"),
                meta: {
                    nameKey: "integralRecordDetails",
                },
            },
            {
                path: "/oper-manage/integral-activity/record/add-record-details",
                name: "积分增长记录详情",
                component: () => import("@/views/oper-manage/integral-activity/integral-activity-record/children/integral-add-record-details/integral-add-record-details.vue"),
                meta: {
                    nameKey: "integralAddRecordDetails",
                },
            },
        ],
    },
    {
        path: "/oper-manage/message/platform-notice",
        name: "平台通知",
        component: () => import("@/views/oper-manage/message/platform-notice/platform-notice.vue"),
        meta: {
            nameKey: "platformNotice",
        },
        children: [
            {
                path: "/oper-manage/message/platform-notice/details",
                name: "平台通知详情",
                component: () => import("@/views/oper-manage/message/platform-notice/children/platform-notice-details/platform-notice-details.vue"),
                meta: {
                    nameKey: "platformNoticeDetails",
                },
            },
        ],
    },
    {
        path: "/oper-manage/points-mall/commodity",
        name: "商品管理",
        component: commodity,
        children: [
            {
                path: "/oper-manage/points-mall/commodity/add",
                name: "新增商品",
                component: addCommodity,
                meta: {
                    nameKey: "addCommodity",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/points-mall/commodity/updata",
                name: "修改商品",
                component: updataCommodity,
                meta: {
                    nameKey: "updataCommodity",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/points-mall/commodity/details",
                name: "商品详情",
                component: detailsCommodity,
                meta: {
                    nameKey: "detailsCommodity",
                },
            },
        ],
    },
    {
        path: "/oper-manage/points-mall/mall-order",
        name: "商品订单",
        component: commodityOrder,
        children: [
            {
                path: "/oper-manage/points-mall/mall-order/details",
                name: "商品订单详情",
                component: commodityOrderDetails,
                meta: {
                    nameKey: "commodityOrderDetails",
                },
            },
        ],
    },
    {
        path: "/oper-manage/points-mall/mall-config",
        name: "商城配置",
        component: mallConfig,
    },
    {
        path: "/oper-manage/message/business-consulting",
        name: "业务咨询",
        component: () => import("@/views/oper-manage/message/business-consulting/business-consulting.vue"),
        meta: {
            nameKey: "businessConsulting",
        },
    },
    {
        path: "/oper-manage/oper-strategy/charging-mode-config",
        name: "充电模式配置",
        component: () => import("@/views/oper-manage/oper-strategy/charging-mode-config/charging-mode-config.vue"),
        children: [
            {
                path: "/oper-manage/oper-strategy/charging-mode-config/charging-mode-config-count",
                name: "有序充电功率均分策略应用数量充电",
                component: () => import("@/views/oper-manage/oper-strategy/charging-mode-config/components/pi-tag-power-sharing/children/charging-mode-config-count/charging-mode-config-count.vue"),
                meta: {
                    nameKey: "qrderlyChargingCount",
                },
            },
            {
                path: "/oper-manage/oper-strategy/charging-mode-config/charging-mode-config-add",
                name: "新增有序充电功率均分策略",
                component: () => import("@/views/oper-manage/oper-strategy/charging-mode-config/components/pi-tag-power-sharing/children/charging-mode-config-add/charging-mode-config-add.vue"),
                meta: {
                    nameKey: "qrderlyChargingAdd",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/oper-strategy/charging-mode-config/charging-mode-config-updata",
                name: "修改有序充电功率均分策略",
                component: () => import("@/views/oper-manage/oper-strategy/charging-mode-config/components/pi-tag-power-sharing/children/charging-mode-config-updata/charging-mode-config-updata.vue"),
                meta: {
                    nameKey: "qrderlyChargingUpdata",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/oper-strategy/charging-mode-config/charging-mode-config-details",
                name: "功率均分策略详情",
                component: () => import("@/views/oper-manage/oper-strategy/charging-mode-config/components/pi-tag-power-sharing/children/charging-mode-config-details/charging-mode-config-details.vue"),
                meta: {
                    nameKey: "qrderlyChargingFirstComeDetails2",
                },
            },
            {
                path: "/oper-manage/oper-strategy/charging-mode-config/operation-record",
                name: "功率均分策略操作记录",
                component: () => import("@/views/oper-manage/oper-strategy/charging-mode-config/components/pi-tag-power-sharing/children/pi-operation-record/pi-operation-record.vue"),
                meta: {
                    nameKey: "qrderlyChargingOperationRecord",
                },
            },
            {
                path: "/oper-manage/oper-strategy/charging-mode-config/charging-mode-config-bind-sta",
                name: "有序充电功率均分策略绑定站点",
                component: () => import("@/views/oper-manage/oper-strategy/charging-mode-config/components/pi-tag-power-sharing/children/charging-mode-config-bind-sta/charging-mode-config-bind-sta.vue"),
                meta: {
                    nameKey: "qrderlyChargingFirstComeBindSta2",
                },
            },
            {
                path: "/oper-manage/oper-strategy/charging-mode-config/first-come-count",
                name: "有序充电先到先充策略应用数量",
                component: () => import("@/views/oper-manage/oper-strategy/charging-mode-config/components/pi-tag-first-come/children/first-come-count/first-come-count.vue"),
                meta: {
                    nameKey: "qrderlyChargingFirstComeCount",
                },
            },
            {
                path: "/oper-manage/oper-strategy/charging-mode-config/first-come-add",
                name: "新增有序充电先到先充策略",
                component: () => import("@/views/oper-manage/oper-strategy/charging-mode-config/components/pi-tag-first-come/children/first-come-add/first-come-add.vue"),
                meta: {
                    nameKey: "qrderlyChargingFirstComeAdd",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/oper-strategy/charging-mode-config/first-come-updata",
                name: "修改有序充电先到先充策略",
                component: () => import("@/views/oper-manage/oper-strategy/charging-mode-config/components/pi-tag-first-come/children/first-come-updata/first-come-updata.vue"),
                meta: {
                    nameKey: "qrderlyChargingFirstComeUpdata",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/oper-strategy/charging-mode-config/first-come-details",
                name: "有序充电先到先充策略详情",
                component: () => import("@/views/oper-manage/oper-strategy/charging-mode-config/components/pi-tag-first-come/children/first-come-details/first-come-details.vue"),
                meta: {
                    nameKey: "qrderlyChargingFirstComeDetails",
                },
            },
            {
                path: "/oper-manage/oper-strategy/charging-mode-config/first-come-bind-sta",
                name: "有序充电先到先充策略绑定站点",
                component: () => import("@/views/oper-manage/oper-strategy/charging-mode-config/components/pi-tag-first-come/children/first-come-bind-sta/first-come-bind-sta.vue"),
                meta: {
                    nameKey: "qrderlyChargingFirstComeBindSta",
                },
            },
        ],
    },
    {
        path: "/oper-manage/oper-strategy/settlement-mode-config",
        name: "结算模式配置",
        component: () => import("@/views/oper-manage/oper-strategy/settlement-mode-config/settlement-mode-config.vue"),
        meta: {
            footerBg: true,
        },
    },
    {
        path: "/oper-manage/oper-strategy/security-policy-config",
        name: "安全策略配置",
        component: () => import("@/views/oper-manage/oper-strategy/security-policy-config/security-policy-config.vue"),
    },
    {
        path: "/oper-manage/oper-strategy/balance-reminder-config",
        name: "余额提醒配置",
        component: () => import("@/views/oper-manage/oper-strategy/balance-reminder-config/balance-reminder-config.vue"),
        children: [
            {
                path: "/oper-manage/oper-strategy/balance-reminder-config/ent-bind-count",
                name: "企业用户关联数",
                component: () => import("@/views/oper-manage/oper-strategy/balance-reminder-config/children/ent-bind-count/ent-bind-count.vue"),
                meta: {
                    nameKey: "balanceReminderEntBindCount",
                },
            },
            {
                path: "/oper-manage/oper-strategy/balance-reminder-config/third-party-bind-count",
                name: "第三方用户关联数",
                component: () => import("@/views/oper-manage/oper-strategy/balance-reminder-config/children/third-party-bind-count/third-party-bind-count.vue"),
                meta: {
                    nameKey: "balanceReminderThirdPartyCount",
                },
            },
            {
                path: "/oper-manage/oper-strategy/balance-reminder-config/add-balance-reminder",
                name: "新增余额提醒",
                component: () => import("@/views/oper-manage/oper-strategy/balance-reminder-config/children/add-balance-reminder/add-balance-reminder.vue"),
                meta: {
                    nameKey: "addBalanceReminder",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/oper-strategy/balance-reminder-config/updata-balance-reminder",
                name: "修改余额提醒",
                component: () => import("@/views/oper-manage/oper-strategy/balance-reminder-config/children/updata-balance-reminder/updata-balance-reminder.vue"),
                meta: {
                    nameKey: "updataBalanceReminder",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/oper-strategy/balance-reminder-config/details-balance-reminder",
                name: "余额提醒详情",
                component: () => import("@/views/oper-manage/oper-strategy/balance-reminder-config/children/details-balance-reminder/details-balance-reminder.vue"),
                meta: {
                    nameKey: "detailsBalanceReminder",
                },
            },
            {
                path: "/oper-manage/oper-strategy/balance-reminder-config/balance-reminder-updata-record",
                name: "余额提醒修改记录",
                component: () => import("@/views/oper-manage/oper-strategy/balance-reminder-config/children/balance-reminder-updata-record/balance-reminder-updata-record.vue"),
                meta: {
                    nameKey: "balanceReminderUpdataRecord",
                },
            },
        ],
    },
    {
        path: "/oper-manage/oper-strategy/expiration-reminder-config",
        name: "到期提醒配置",
        component: () => import("@/views/oper-manage/oper-strategy/expiration-reminder-config/expiration-reminder-config.vue"),
        meta: {
            footerBg: true,
        },
    },
    {
        path: "/oper-manage/oper-strategy/account-config",
        name: "账户配置",
        component: () => import("@/views/oper-manage/oper-strategy/account-config/account-config.vue"),
        meta: {
            footerBg: true,
        },
    },
    {
        path: "/oper-manage/oper-strategy/integral-switch-config",
        name: "积分开关配置",
        component: () => import("@/views/oper-manage/oper-strategy/integral-switch-config/integral-switch-config.vue"),
    },
    {
        path: "/oper-manage/oper-strategy/charging-error-config",
        name: "充电异常提醒配置",
        component: () => import("@/views/oper-manage/oper-strategy/charging-error-config/charging-error-config.vue"),
    },
    {
        path: "/oper-manage/order-manage/charge-order-list",
        name: "充电订单",
        component: () => import("@/views/oper-manage/order-manage/charge-order-list/charge-order-list.vue"),
        children: [
            {
                path: "/oper-manage/order-manage/charge-order-list/charge-order-detail",
                name: "订单详情",
                component: () => import("@/views/oper-manage/order-manage/charge-order-list/children/charge-order-detail/charge-order-detail.vue"),
                meta: {
                    nameKey: "chargeOrderDetail",
                },
            },
            {
                path: "/oper-manage/order-manage/charge-order-list/abnormal-order",
                name: "充电异常处理",
                component: () => import("@/views/oper-manage/order-manage/charge-order-list/children/abnormal-order/abnormal-order.vue"),
                meta: {
                    nameKey: "abnormalOrder",
                },
            },
        ],
    },
    {
        path: "/oper-manage/order-manage/off-card-order",
        name: "离线卡订单",
        component: () => import("@/views/oper-manage/order-manage/off-card-order-list/off-card-order-list.vue"),
        children: [
            {
                path: "/oper-manage/order-manage/off-card-order/charge-order-detail",
                name: "离线卡订单详情",
                component: () => import("@/views/oper-manage/order-manage/off-card-order-list/children/off-order-detail.vue"),
                meta: {
                    nameKey: "offCardOrderDetails",
                },
            },
        ],
    },
    {
        path: "/oper-manage/order-manage/reserve-charging-order",
        name: "预约充电订单",
        component: () => import("@/views/oper-manage/order-manage/reserve-charging-order/reserve-charging-order.vue"),
        children: [
            {
                path: "/oper-manage/order-manage/reserve-charging-order/details",
                name: "预约充电订单详情",
                component: () => import("@/views/oper-manage/order-manage/reserve-charging-order/children/reserve-charging-order-detail/reserve-charging-order-detail.vue"),
                meta: {
                    nameKey: "reserveChargingOrderDetails",
                },
            },
        ],
    },
    {
        path: "/oper-manage/order-manage/charge-error-order",
        name: "异常订单",
        component: () => import("@/views/oper-manage/order-manage/charge-error-order/charge-error-order.vue"),
        children: [
            {
                path: "/oper-manage/order-manage/charge-error-order/charge-order-detail",
                name: "订单详情",
                component: () => import("@/views/oper-manage/order-manage/charge-order-list/children/charge-order-detail/charge-order-detail.vue"),
                meta: {
                    nameKey: "errorOrderDetail",
                },
            },
            {
                path: "/oper-manage/order-manage/charge-error-order/abnormal-order",
                name: "异常处理",
                component: () => import("@/views/oper-manage/order-manage/charge-order-list/children/abnormal-order/abnormal-order.vue"),
                meta: {
                    nameKey: "abnormalErrorOrder",
                },
            },
        ],
    },
    {
        path: "/oper-manage/fee-manage/charge-fee",
        name: "费率管理",
        component: () => import("@/views/oper-manage/fee-manage/charge-fee/fee-manage.vue"),
        children: [
            {
                path: "/oper-manage/fee-manage/charge-fee/fee-station-detail",
                name: "充电费率交直流充电桩充电费率",
                component: () => import("@/views/oper-manage/fee-manage/charge-fee/children/fee-station-detail/fee-station-detail.vue"),
                meta: {
                    nameKey: "feePileDetail",
                },
            },
            {
                path: "/oper-manage/fee-manage/charge-fee/add-fee",
                name: "新增费率",
                component: () => import("@/views/oper-manage/fee-manage/charge-fee/children/add-fee/add-fee.vue"),
                meta: {
                    nameKey: "addFee",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/fee-manage/charge-fee/edit-fee",
                name: "编辑费率",
                component: () => import("@/views/oper-manage/fee-manage/charge-fee/children/edit-fee/edit-fee.vue"),
                meta: {
                    nameKey: "editFee",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/fee-manage/charge-fee/fee-record",
                name: "费率-记录",
                component: () => import("@/views/oper-manage/fee-manage/charge-fee/children/fee-manage-record/fee-manage-record.vue"),
                meta: {
                    nameKey: "feePageRecord",
                },
            },
            {
                path: "/oper-manage/fee-manage/charge-fee/count-detail",
                name: "使用数量",
                component: () => import("@/views/oper-manage/fee-manage/charge-fee/children/count-detail/count-detail.vue"),
                meta: {
                    nameKey: "feePageUseNum",
                },
            },
            {
                path: "/oper-manage/fee-manage/charge-fee/pending-num",
                name: "待下发数量",
                component: () => import("@/views/oper-manage/fee-manage/charge-fee/children/pending-effective-num/pending-effective-num.vue"),
                meta: {
                    nameKey: "feePagePendingNum",
                },
            },
            {
                path: "/oper-manage/fee-manage/charge-fee/pending-fee",
                name: "待生效费率",
                component: () => import("@/views/oper-manage/fee-manage/charge-fee/children/pending-effective-fee/pending-effective-fee.vue"),
                meta: {
                    nameKey: "feePagePendingFee",
                },
            },
            {
                path: "/oper-manage/fee-manage/charge-fee/fee-station-batch-change",
                name: "充电费率-批量更换费率",
                component: () => import("@/views/oper-manage/fee-manage/charge-fee/children/fee-station-batch-change/fee-station-batch-change.vue"),
                meta: {
                    nameKey: "feeStationBatchChange",
                },
            },
            {
                path: "/oper-manage/fee-manage/charge-fee/fee-price-updata",
                name: "企业费率-电价修改",
                component: () => import("@/views/oper-manage/fee-manage/charge-fee/children/fee-price-updata/fee-price-updata.vue"),
                meta: {
                    nameKey: "entFeeUpdata",
                },
            },
            {
                path: "/oper-manage/fee-manage/charge-fee/fee-bind-station",
                name: "企业费率-关联站点",
                component: () => import("@/views/oper-manage/fee-manage/charge-fee/children/fee-bind-station/fee-bind-station.vue"),
                meta: {
                    nameKey: "feeBindStation",
                },
            },
            {
                path: "/oper-manage/fee-manage/charge-fee/fee-bind-station-list",
                name: "企业费率-关联站点列表",
                component: () => import("@/views/oper-manage/fee-manage/charge-fee/children/fee-bind-station-list/fee-bind-station-list.vue"),
                meta: {
                    nameKey: "feeBindStationList",
                },
            },
        ],
    },
    {
        path: "/oper-manage/fee-manage/delay-fee",
        name: "占桩费率管理",
        component: () => import("@/views/oper-manage/fee-manage/delay-fee/delay-fee.vue"),
        children: [
            {
                path: "/oper-manage/fee-manage/delay-fee/add",
                name: "新增占桩费率",
                component: () => import("@/views/oper-manage/fee-manage/delay-fee/children/add-fee/add-fee.vue"),
                meta: {
                    nameKey: "delayFeeAdd",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/fee-manage/delay-fee/updata",
                name: "修改占桩费率",
                component: () => import("@/views/oper-manage/fee-manage/delay-fee/children/delay-edit-fee/delay-edit-fee.vue"),
                meta: {
                    nameKey: "delayFeeUpdata",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/fee-manage/delay-fee/count",
                name: "占桩费率使用数量",
                component: () => import("@/views/oper-manage/fee-manage/delay-fee/children/count-detail/count-detail.vue"),
                meta: {
                    nameKey: "delayCountDetail",
                },
            },
            {
                path: "/oper-manage/fee-manage/delay-fee/details",
                name: "占桩费率详情",
                component: () => import("@/views/oper-manage/fee-manage/delay-fee/children/delay-fee-detail/delay-fee-detail.vue"),
                meta: {
                    nameKey: "delayFeeDetails",
                },
            },
            {
                path: "/oper-manage/fee-manage/delay-fee/rate-distribution",
                name: "占桩费率下发",
                component: () => import("@/views/oper-manage/fee-manage/delay-fee/children/pi-delay-rate-distribution/pi-delay-rate-distribution.vue"),
                meta: {
                    nameKey: "delayRateDistribution",
                },
            },
            {
                path: "/oper-manage/fee-manage/delay-fee/change-record",
                name: "占桩费率修改记录",
                component: () => import("@/views/oper-manage/fee-manage/delay-fee/children/pi-delay-change-record/pi-delay-change-record.vue"),
                meta: {
                    nameKey: "delayRateRecord",
                },
            },
        ],
    },
    {
        path: "/oper-manage/fee-manage/reservation-rate",
        name: "预约费率管理",
        component: () => import("@/views/oper-manage/fee-manage/reservation-rate/reservation-rate.vue"),
        children: [
            {
                path: "/oper-manage/fee-manage/reservation-rate/add-fee",
                name: "新增预约费率管理",
                component: () => import("@/views/oper-manage/fee-manage/reservation-rate/children/add-fee/add-fee.vue"),
                meta: {
                    nameKey: "addReservationRate",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/fee-manage/reservation-rate/edit-fee",
                name: "修改预约费率管理",
                component: () => import("@/views/oper-manage/fee-manage/reservation-rate/children/edit-fee/edit-fee.vue"),
                meta: {
                    nameKey: "updataReservationRate",
                    footerBg: true,
                },
            },
            {
                path: "/oper-manage/fee-manage/reservation-rate/count",
                name: "预约费率使用站点",
                component: () => import("@/views/oper-manage/fee-manage/reservation-rate/children/count-detail/count-detail.vue"),
                meta: {
                    nameKey: "reservationRateCount",
                },
            },
            {
                path: "/oper-manage/fee-manage/reservation-rate/fee-pile-detail",
                name: "预约费率详情",
                component: () => import("@/views/oper-manage/fee-manage/reservation-rate/children/fee-pile-detail/fee-pile-detail.vue"),
                meta: {
                    nameKey: "detailsReservationRate",
                },
            },
            {
                path: "/oper-manage/fee-manage/reservation-rate/rate-distribution",
                name: "预约费率下发",
                component: () => import("@/views/oper-manage/fee-manage/reservation-rate/children/pi-rate-distribution/pi-rate-distribution.vue"),
                meta: {
                    nameKey: "reservationRateDistribution",
                },
            },
            {
                path: "/oper-manage/fee-manage/reservation-rate/change-record",
                name: "预约费率修改记录",
                component: () => import("@/views/oper-manage/fee-manage/reservation-rate/children/pi-change-record/pi-change-record.vue"),
                meta: {
                    nameKey: "reservationRateRecord",
                },
            },
        ],
    },
    {
        path: "/oper-manage/fee-manage/fee-use-details",
        name: "费率应用明细",
        component: () => import("@/views/oper-manage/fee-manage/fee-use-details/fee-use-details.vue"),
        children: [
            {
                path: "/oper-manage/fee-manage/fee-use-details/details",
                name: "费率清单交直流充电桩充电费率",
                component: () => import("@/views/oper-manage/fee-manage/fee-use-details/children/fee-detail/fee-detail.vue"),
                meta: {
                    nameKey: "feeUsePileDetail",
                },
            },
            {
                path: "/oper-manage/fee-manage/fee-use-details/sta-details",
                name: "费率详情",
                component: () => import("@/views/oper-manage/fee-manage/fee-use-details/children/details/details.vue"),
                meta: {
                    nameKey: "feeDetails",
                },
            },
        ],
    },
    {
        path: "/oper-manage/operational-overview",
        name: "运营概览",
        component: () => import("@/views/oper-manage/operational-overview/operational-overview.vue"),
    },
    {
        path: "/oper-manage/battery-test",
        name: "电池检测管理",
        component: () => import("@/views/oper-manage/battery-test/battery-test.vue"),
        children: [
            {
                path: "/oper-manage/battery-test/details",
                name: "报告详情",
                component: () => import("@/views/oper-manage/battery-test/children/battery-test-details/battery-test-details.vue"),
                meta: {
                    nameKey: "batteryTestDetails",
                },
            },
        ],
    },
];
export default routerList;
